// extracted by mini-css-extract-plugin
export default {"appointmentDetailsTab":"TabButton_appointmentDetailsTab__a6Lzr","selectedAppointmentTab":"TabButton_selectedAppointmentTab__-iIog"};